import { Content } from "../Posts";

export interface User {
  id: number;
  name: string;
  email: string;
  investor_type: number;
  profile_picture: string;
  is_premium: number;
  created_at: Date;
  updated_at: Date;
  email_verified_at?: any;
}

export enum eInteraction {
  REACTION = 1,
  COMMENT = 2,
}

export interface Interaction {
  id: number;
  interactable_type: string;
  interactable_id: number;
  content: Content;
  type: eInteraction;
  user_id: number;
  created_at: Date;
  updated_at: Date;
  deleted_at?: any;
  user: User;
}

export interface StoreInteractionRequest {
  interactable_id: number;
  interactable_type: string;
  content: string;
  type: eInteraction;
}

export interface UpdateInteractionResponse {
  id: number;
  interactable_type: string;
  interactable_id: number;
  content: string;
  type: number;
  user_id: number;
  created_at: string;
  updated_at: string;
  deleted_at: any;
  user: User;
}
